import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { X, ArrowLeft, Printer, LoaderCircle } from "lucide-react";
import { CaptureImgCom, NotFoundCom, WaitComponent } from "./CommonCom";
import { APIEND_POINT, APIUtility } from "../Api";
import cameraLoad from "../images/cameraLoad.gif";
import ImageWithRect from "../components/Common/ImageWithRect";
import { useDispatch, useSelector } from "react-redux";
import { setUserVehicleMappingId } from "../Redux/CommonSlice/allDataSlice";

const BoombarrierModal = (props) => {

  const playerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isNoPlateDetected, seyIsNoPlateDetected] = useState(false);
  const [captureStatus, setCaptureStatus] = useState("capture");
  const [boomBarrierData, setBoomBarrierData] = useState(null);
  const [capturedImage, setCapturesImages] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [printStatus, setPrintStatus] = useState("initial");

  const { show, onHide, setSocketOpen, socketOpen, isLiveStreamStart, cameraFrame, noCameraFound } = props;

  const canvasRef = useRef(null);
  const blob = new Blob([cameraFrame], { type: "image/jpeg" });
  const objectURL = URL.createObjectURL(blob);

  const dispatch = useDispatch();
  const userVehicleMappingId = useSelector((state) => state.data.userVehicleMappingId);

  useEffect(() => {
    setCaptureStatus("capture");
    setPrintStatus("initial");
  }, [show]);

  const downloadImg = () => {
    if (!cameraFrame) return;

    const downloadLink = document.createElement("a");
    downloadLink.href = objectURL;
    downloadLink.download = "captured_image.jpeg";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Revoke the object URL after the download is initiated
    URL.revokeObjectURL(objectURL);
  };

  const CaptureImage = () => {
    const formData = new FormData();
    setIsLoading(true);
    setCaptureStatus("loading");

    if (cameraFrame) {
      setSocketOpen(false);

      formData.append("file", blob, "captured_image1.jpeg");
      formData.append("file", blob, "captured_image2.jpeg");
      formData.append("file", blob, "captured_image3.jpeg");
      formData.append("file", blob, "captured_image4.jpeg");
      formData.append("file", blob, "captured_image5.jpeg");

      formData.append("camera_id", 7);
      formData.append("user_id", 1);
      formData.append("plant_details_id", 1);
      formData.append("camera", 1);
      setCapturesImages(objectURL);

      const sendImage = async () => {
        try {
          const res = await APIUtility.boomBarrierImageSend(formData);
          if (res.status === 200 || res.status === 201) {
            setIsLoading(false);
            const data = res.data;
            setBoomBarrierData(data);

            if (data.user_vehicle_mapping_id) {
              dispatch(setUserVehicleMappingId(data.user_vehicle_mapping_id));
            }
            if (
              data?.vechicle_info.license_plate &&
              data?.vechicle_info.license_plate !== ""
            ) {
              setCaptureStatus("NumberDetected");
              setSocketOpen(false);
            } else {
              seyIsNoPlateDetected(false);
              setSocketOpen(true);
              setCaptureStatus("recapture");
            }
          } else {
            setIsLoading(false);
            setSocketOpen(true);
            setCaptureStatus("recapture");
          }
        } catch (error) {
          console.log(error, "error");
          setIsLoading(false);
          setSocketOpen(true);
          setCaptureStatus("recapture");
        }
      };
      sendImage();
    }
  };

  const handlePrintQRCode = async () => {
    if (!userVehicleMappingId) return;

    setIsPrinting(true);
    try {
      const response = await APIUtility.printQRCode({
        user_vehicle_mapping_id: userVehicleMappingId
      });

      if (response.status === 200) {
        setPrintStatus("printed");
      }
    } catch (error) {
      console.error("Error printing QR code:", error);
    } finally {
      setIsPrinting(false);
    }
  };


  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="!p-0">
          <button
            className=" absolute right-[10px] top-[10px] text-black"
            onClick={() => onHide()}
          >
            <X size={26} />
          </button>
          <div className="flex w-full">
            <div className=" w-[68%] h-full bg-[#F9F9F7] py-[20px] px-[20px] rounded-s-xl">
              <div className="flex flex-col h-full">
                <h3 className="flex items-center gap-3 font-bold text-[18px]">
                  <ArrowLeft
                    className=" cursor-pointer"
                    onClick={() => onHide()}
                  />{" "}
                  Capture Vehicle No. Plate
                </h3>

                <div className="w-full h-[80vh] lgLp:h-[80vh] flex-grow pt-2">
                  {!socketOpen ? (
                    <ImageWithRect
                      data={{
                        img: capturedImage,
                        label:
                          captureStatus == "NumberDetected"
                            ? boomBarrierData?.vechicle_info.license_plate
                            : "-",
                        ...boomBarrierData?.vechicle_info,
                      }}
                    />
                  ) : (
                    // <img
                    //   className="w-full h-full object-fill rounded-lg"
                    //   src={capturedImage}
                    //   alt="Captured"
                    // />


                    noCameraFound ? <div className="w-full h-full bg-white flex items-center justify-center">

                      <img
                        className="w-auto h-auto object-fill rounded-lg"
                        id="liveViewId"
                        ref={playerRef}
                        src={'https://t3.ftcdn.net/jpg/05/15/33/64/360_F_515336412_OgofSpIb0z5iw8GLSh1PI5mNHNOmrcEG.jpg'}
                      />
                    </div> : isLiveStreamStart ? <img
                      className="w-full h-full object-fill rounded-lg"
                      id="liveViewId"
                      ref={playerRef}
                      src={objectURL}
                    /> : <div className="w-full h-full flex items-center justify-center">

                      <img
                        className="w-auto h-auto object-fill rounded-lg"
                        id="liveViewId"
                        ref={playerRef}
                        src={cameraLoad}
                      />
                    </div>

                  )}
                </div>
              </div>
            </div>
            <div className="w-[32%] py-[20px] px-[20px] ">
              <h3 className="flex items-center gap-3 font-bold text-[18px]">
                QR Code And Details
              </h3>

              <div
                className="py-4 px-[0px] flex rounded-[5px] items-center flex-col justify-center w-full"
                style={{ background: "rgba(196, 196, 196, 0.10)" }}
              >
                {captureStatus == "loading" ? (
                  <WaitComponent />
                ) : captureStatus == "recapture" ? (
                  <NotFoundCom
                    onClick={CaptureImage}
                    isLiveStreamStart={isLiveStreamStart}
                  />
                ) : captureStatus == "capture" ? (
                  <CaptureImgCom
                    onClick={CaptureImage}
                    isLiveStreamStart={isLiveStreamStart}
                  />
                ) : (
                  <div className="w-full flex items-center justify-center">
                    <img
                      className="h-[150px] lgLp:h-[250px] object-fill"
                      src={APIEND_POINT + boomBarrierData?.qr_image}
                    />
                    {/* <h4 className=" text-[14px] font-medium text-black mt-2">
                  {captureStatus=='NumberDetected'?boomBarrierData.qr_data:'-'}
                  </h4> */}
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-2 mt-3">
                <div className="h-[55px] border-b flex items-center  justify-between">
                  <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                    QR Code :
                  </h4>
                  <h2 className=" text-[14px] font-medium text-black break-normal">
                    {captureStatus == "NumberDetected"
                      ? boomBarrierData.qr_data
                      : "-"}
                  </h2>
                </div>
                <div className="h-[50px] border-b flex items-center justify-between">
                  <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                    Vehicle No. :
                  </h4>

                  <h2 className=" text-[14px] font-medium text-black break-normal">
                    {captureStatus == "NumberDetected"
                      ? boomBarrierData?.vechicle_info.license_plate
                      : "-"}
                  </h2>
                </div>
                <div className="h-[50px] border-b flex items-center justify-between">
                  <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                    Date and Time :
                  </h4>
                  <h2 className=" text-[14px] font-medium text-black break-normal">
                    {captureStatus == "NumberDetected"
                      ? boomBarrierData?.date
                      : "-"}{" "}
                    {captureStatus == "NumberDetected"
                      ? boomBarrierData?.time
                      : ""}
                  </h2>
                </div>
              </div>
              {captureStatus === "NumberDetected" && (
                <button
                  onClick={handlePrintQRCode}
                  disabled={isPrinting || printStatus === "printed" || !userVehicleMappingId}
                  className={`mx-auto mt-[15px] rounded-[3px] flex items-center justify-center gap-2 font-bold text-[16px] px-4 h-[47px] transition-all
                    ${printStatus === "printed"
                      ? "bg-green-50 text-green-600 hover:text-green-700 [&_svg]:hover:text-green-700 border-2 border-green-600"
                      : "bg-[#F5F5F5] hover:bg-[#EBEBEB]"
                    }`}
                >
                  {isPrinting ? (
                    <>
                      <LoaderCircle className="animate-spin" size={23} /> Printing...
                    </>
                  ) : printStatus === "printed" ? (
                    <>
                      <Printer className="text-green-600 transition-colors" /> QR Code Printed
                    </>
                  ) : (
                    <>
                      <Printer /> Print QR Code
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BoombarrierModal;
